import { saveAs } from 'file-saver';
import { ChangeDetectorRef, Injectable } from '@angular/core';
import { ListHelperService, PopUpService, ProfileService, StoreService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { Router } from '@angular/router';
import { KeplerService } from 'app/kepler/services/kepler.service';

@Injectable()
export class KeplerGoalListService {
  userRole: any;
  private dataSource: any;
  constructor(
    public keplerService: KeplerService,
    public translate: TranslateService,
    public profileService: ProfileService,
    public listHelper: ListHelperService,
    public popupService: PopUpService,
    public router: Router,
    public cdr: ChangeDetectorRef
  ) {
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  async getDatasource(listId, match, options: any = {}) {
    const docs = match
      ? match.roundsEndDates.map((kpiUploadDate, index) => ({ date: kpiUploadDate, roundIndex: index + 1 })).reverse()
      : [];
    this.dataSource = new TableDatasource({
      columns: this.getColumns(match.id),
      docs,
      ...options
    });
    StoreService.create(listId, this.dataSource);
    return this.dataSource;
  }

  getColumns(matchId) {
    const columns = [
      {
        source: 'date',
        label: this.translate.instant('kepler.kpiCreatedAt'),
        dataType: DataTypes.datetime,
        sortable: false,
        valueParser: (value) => this.listHelper.parseDate(value, value.timezone)
      },
      {
        source: 'roundIndex',
        label: this.translate.instant('kepler.kpiNum'),
        dataType: DataTypes.number,
        sortable: false
      },
      {
        alignment: 'right',
        style: { width: '100px' },
        showInColumnChooser: false,
        cellRenderer: (renderer, value, round) => {
          return renderer`
            <gl-button icon icon-center="glicon-download-file" @click="${() =>
              this.kpiDownload(matchId, round.roundIndex)}"></gl-button>
          `;
        }
      }
    ];
    return columns;
  }

  public kpiDownload(matchId, roundIndex) {
    this.keplerService.getRoundCsv(matchId, roundIndex).subscribe({
      next: (response) => {
        const contentDisposition = response.headers.get('content-disposition') || '';
        const matches = /filename=([^;]+)/gi.exec(contentDisposition);
        const fileName = (matches?.length ? matches[1].slice(1, -1) : `KeplerKPIs_${roundIndex}_${matchId}.csv`).trim();
        saveAs(response.body, fileName);
        this.dataSource.refresh();
      },
      error: (error) => {
        this.popupService.showError({
          title: 'Error',
          text: error.serverMessage
        });
      }
    });
  }
}
